const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// http://localhost:8000"
// "https://ee94-2406-7400-63-31e2-00-10e.ngrok-free.app";

export const API_URL = BASE_URL;
// export const API_URL = "http://127.0.0.1:8000";
